// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  environment: 'development',
  production: false,
  maintenance: false,
  firebase: {
    apiKey: 'AIzaSyD3TGtvwVoEuj8tLfXcOGXQrNRQBxMJy18',
    authDomain: 'tabbassi-test.firebaseapp.com',
    databaseURL: 'https://tabbassi-test.firebaseio.com/',
    projectId: 'tabbassi-test',
    storageBucket: 'tabbassi-test.appspot.com',
    messagingSenderId: '482187244704',
    appId: '1:482187244704:web:96e10f195265979ee705c5',
    measurementId: 'G-74GSR102LM',
  },
  apiUrl: 'https://test-be.racebet365.com',
  talkjsAppID: 't5zRSASb',
  // SUPABASE_URL: 'https://npuxcqiwtzbrulwvwiee.supabase.co',
  // SUPABASE_ANON_KEY:
  //   'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5wdXhjcWl3dHpicnVsd3Z3aWVlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MjgzOTgxNzQsImV4cCI6MjA0Mzk3NDE3NH0.QCNSdovTx0k9Sferf9rJj0HNyE7wFenyMdvDalG_Ysc',
  SUPABASE_URL: 'https://lbaafmqcmtdxpsrihxzk.supabase.co',
  SUPABASE_ANON_KEY:
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxiYWFmbXFjbXRkeHBzcmloeHprIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MjQxNzA3NjcsImV4cCI6MjAzOTc0Njc2N30.iBZfJzbHHQI4Uxc094JfP03l77arcVx6pCamplnGDfc',
  // apiUrl: 'http://localhost:5003/tabbassi-test/europe-west1',
};

// export const environment = {
//   environment: 'production',
//   production: true,
//   maintenance: false,
//   firebase: {
//     apiKey: 'AIzaSyBw-6Z_UKL4FClC7oqhyeo7vRXpe65jJ28',
//     authDomain: 'forza-281113.firebaseapp.com',
//     databaseURL: 'https://forza-281113.firebaseio.com',
//     projectId: 'forza-281113',
//     storageBucket: 'forza-281113.appspot.com',
//     messagingSenderId: '365356080748',
//     appId: '1:365356080748:web:dafd3c736dfe88765ec249',
//   },
//   SUPABASE_URL: 'https://lbaafmqcmtdxpsrihxzk.supabase.co',
//   SUPABASE_ANON_KEY:
//     'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxiYWFmbXFjbXRkeHBzcmloeHprIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MjQxNzA3NjcsImV4cCI6MjAzOTc0Njc2N30.iBZfJzbHHQI4Uxc094JfP03l77arcVx6pCamplnGDfc',
//   apiUrl: 'https://api.racebet365.com',
//   talkjsAppID: '1pBkW5nX',
// };


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
